import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-data-received-latency',
  standalone: true,
  imports: [
    MatIconModule,
  ],
  templateUrl: './data-received-latency.component.html',
  styleUrl: './data-received-latency.component.scss'
})
export class DataReceivedLatencyComponent implements CellRenderer<any>  {
  @Input() params!: CellRendererParams<any>;

  openLogDetailModal(element): void {
    this.params.colDef?.cellRendererParams?.onClick(element);
  }
}
